/* eslint-disable */
export enum FSFBJSONUnion {
  NONE = 0,
  FSFBJSONObject = 1,
  FSFBJSONArray = 2,
  FSFBJSONValue = 3,
}
